import { render, staticRenderFns } from "./TelecomsPricingModal.vue?vue&type=template&id=0158c147&"
import script from "./TelecomsPricingModal.vue?vue&type=script&lang=js&"
export * from "./TelecomsPricingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports